import xhr from './xhrFactory'
import moment from 'moment'

/**
 * @typedef {object} LicenseContent
 * @property {{Promise<import('./CustomerLicenseDataDto').CustomerLicenseDataDto>}} waiverData
 * @property {boolean} licenseDecoded - tells if the decoding the license was successful or not
 */

/**
 * Get Driver's License content
 * @async
 * @param {string} slug
 * @returns {LicenseContent}
 */
async function postLicense(data) {
  const result = await xhr({ timeout: 30000 }).post(`/member/customer-waiver/license-decoding`, {
    recognizerType: 'USDL',
    imageBase64: data
  })
  return { isDecoded: Object.keys(result.data).length > 0, waiverData: mapToWaiverDto(result.data) }

  // return mapToWaiverDto({
  //   driverFirstName: 'SCOTT',
  //   driverLastName: 'COLESTOCK',
  //   driverPostalCode: null,
  //   driverDOB: '1971-02-02T00:00:00.000Z',
  //   driverLicenseState: null,
  //   driverLicenseNumber: 'W203256878305',
  //   driverAddressLine1: null,
  //   driverAddressLine2: null,
  //   driverAddressCity: null,
  //   driverAddressState: null,
  //   driverAddressCountry: null,
  //   driverHasMotorcycleLicense: false
  // })
}

// TODO: someday I want to align the Dto and the IndianWaiverSteps components. Until then, we need this mapping.

/**
 * @param {import('./CustomerLicenseDataDto').CustomerLicenseDataDto} dto
 */
function mapToWaiverDto(dto) {
  return {
    firstName: dto.driverFirstName || '',
    lastName: dto.driverLastName || '',
    postalCode: dto.driverPostalCode || '',
    birthDate: dto.driverDOB ? moment.utc(dto.driverDOB).format('MM/DD/YYYY') : '',
    driversLicenseState: dto.driverLicenseState || '',
    driversLicense: dto.driverLicenseNumber || '',
    addressLine1: dto.driverAddressLine1 || '',
    addressLine2: dto.driverAddressLine2 || '',
    city: dto.driverAddressCity || '',
    state: dto.driverAddressState || '',
    country: dto.driverAddressCountry || '',
    driverHasMotorcycleLicense: dto.driverHasMotorcycleLicense || false,
    driversLicenseCountry: dto.driverAddressCountry || ''
  }
}

const scans = {
  postLicense
}
export default scans
